import PropTypes from "prop-types"
import moment from "moment"
import { chain } from "lodash"
import { GetApp } from "@mui/icons-material"
import { GRACE_PERIOD } from "modules/data-cloud/helpers"
import Table from "components/material/table"
import Tooltip from "components/material/tooltip"
import { getExpirationElement } from "./helpers"
import { ROLE } from "helpers/shapes"
import { makeDatasetElementRender } from "helpers/datasets"

import "./style.scss"

export default function Subscriptions({ datasets, role, account, entitlementsEnabled }) {
  // Keep expired subscriptions that are within the grace period (30 days)
  const ordered = chain(datasets)
    .filter(({ expiration }) => moment(expiration).add(GRACE_PERIOD, "days").isSameOrAfter(moment(), "day"))
    .orderBy(({ expiration }) => moment(expiration).format("x"), ["desc"])
    .value()

  // Same function for all table elements
  const getDatasetElement = makeDatasetElementRender(account, role, entitlementsEnabled, 300)
  const columns = [
    {
      name: "",
      id: "expiration",
      render: getExpirationElement,
    },
    {
      name: "Name",
      id: "name",
      render: getDatasetElement,
    },
    {
      name: "Type",
      id: "type",
    },
    {
      name: "Publisher",
      id: "publisher",
    },
    {
      name: "Region",
      id: "region",
    },
    {
      name: "Latest date",
      id: "availability.currentDate",
      formatter: (value) => value || "-",
    },
    {
      name: "",
      id: "saleSheet",
      render: ({ saleSheet }) => saleSheet ? <Tooltip title="Download sale sheet">
        <a target="_blank" rel="noreferrer" href={saleSheet}><GetApp /></a>
      </Tooltip> : null,
    }]

  return <div className="subscriptions">
    <div className="active">
      <Table
        title="Active subscriptions"
        stickyHeaders
        idField="id"
        addForm={false}
        data={ordered}
        columns={columns}
      />

    </div>
  </div>
}

Subscriptions.propTypes = {
  datasets: PropTypes.array.isRequired,
  role: ROLE.isRequired,
  account: PropTypes.string.isRequired,
  entitlementsEnabled: PropTypes.bool.isRequired,
}
